// extracted by mini-css-extract-plugin
export default {"footer":"styles_footer__8gle9","innerFooter":"styles_innerFooter__-y-tz","logo":"styles_logo__8Muyx","disclaimer":"styles_disclaimer__-Wuqd","ui-spin":"styles_ui-spin__f734-"};